__turbopack_context__.v({
  "className": "poppins_cfab3cb8-module__3p_xoG__className",
  "variable": "poppins_cfab3cb8-module__3p_xoG__variable",
});
